import { ScrollReveal } from "@/components/base/ScrollAnimations";

const sections = [
  {
    title: "1. Introduction",
    content:
      "Textile Innovation Exchange (\"TIE\", \"we\", \"us\", or \"our\") is committed to protecting your privacy. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our website, use our services, or participate in our programmes. Please read this policy carefully. If you do not agree with the terms of this policy, please do not access the site or use our services.",
  },
  {
    title: "2. Information We Collect",
    content:
      "We may collect personal information that you voluntarily provide to us when you register for programmes, submit enquiries, sign up for newsletters, or contact us. This may include your name, email address, phone number, company name, job title, and any other details you choose to share. We also collect non-personal information such as browser type, IP address, device information, and pages visited through cookies and similar technologies.",
  },
  {
    title: "3. How We Use Your Information",
    content:
      "We use the information we collect to: respond to your enquiries and provide customer support; process programme registrations and collaboration requests; send you updates, newsletters, and marketing communications (which you can opt out of at any time); improve our website, services, and user experience; conduct research and analysis to advance textile innovation in Bangladesh; and comply with legal obligations and enforce our terms.",
  },
  {
    title: "4. Data Sharing and Disclosure",
    content:
      "We do not sell your personal information. We may share information with: our partner organizations (BKMEA, BGBA) when necessary for programme delivery; service providers who assist us in operating our website and conducting our business; legal authorities when required by law or to protect our rights; and other participants in anonymized or aggregated form for research purposes. Any third parties who receive your data are contractually obligated to keep it confidential and use it only for the specified purposes.",
  },
  {
    title: "5. Data Security",
    content:
      "We implement appropriate technical and organizational measures to protect your personal information against unauthorized access, alteration, disclosure, or destruction. These measures include SSL encryption for data transmission, restricted access controls, and regular security assessments. However, no method of transmission over the internet or electronic storage is 100% secure, and we cannot guarantee absolute security.",
  },
  {
    title: "6. Cookies and Tracking Technologies",
    content:
      "Our website uses cookies and similar tracking technologies to enhance your browsing experience, analyze site traffic, and understand where our visitors come from. You can set your browser to refuse all or some browser cookies, or to alert you when cookies are being sent. If you disable or refuse cookies, some parts of the site may become inaccessible or not function properly.",
  },
  {
    title: "7. Your Rights",
    content:
      "Depending on your location, you may have the right to: access the personal information we hold about you; request correction or deletion of your personal information; object to or restrict the processing of your data; withdraw consent where processing is based on consent; and lodge a complaint with a data protection authority. To exercise these rights, please contact us using the details provided in the Contact section.",
  },
  {
    title: "8. Data Retention",
    content:
      "We retain your personal information for as long as necessary to fulfill the purposes outlined in this policy, unless a longer retention period is required or permitted by law. Programme participant data is typically retained for the duration of the programme plus three years to support follow-up research, longitudinal studies, and impact assessment.",
  },
  {
    title: "9. Children's Privacy",
    content:
      "Our services are not directed to individuals under the age of 18. We do not knowingly collect personal information from children. If you are a parent or guardian and believe your child has provided us with personal information, please contact us immediately. If we learn we have collected personal information from a child, we will delete that information as quickly as possible.",
  },
  {
    title: "10. International Data Transfers",
    content:
      "Your information may be transferred to and processed in countries other than the country in which you reside. These countries may have data protection laws that are different from those in your country. We ensure that appropriate safeguards are in place to protect your information when it is transferred internationally, in compliance with applicable data protection regulations.",
  },
  {
    title: "11. Changes to This Policy",
    content:
      "We may update this Privacy Policy from time to time to reflect changes in our practices, legal requirements, or operational needs. We will post the revised policy on this page with an updated effective date. We encourage you to review this policy periodically to stay informed about how we are protecting your information.",
  },
  {
    title: "12. Contact Us",
    content:
      "If you have any questions, concerns, or requests regarding this Privacy Policy or our data practices, please contact us at info@textileinnovationexchange.com or by mail at Textile Innovation Exchange, 47, Road 3, Sector 13, Uttara, Dhaka, Bangladesh.",
  },
];

export default function PrivacyContent() {
  return (
    <section className="bg-white py-16 md:py-24">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="max-w-3xl mx-auto">
          <div className="space-y-10 md:space-y-14">
            {sections.map((section, i) => (
              <ScrollReveal key={section.title} delay={i * 50}>
                <div>
                  <h2 className="font-serif text-xl md:text-2xl font-bold text-tie-text-primary mb-3 md:mb-4">
                    {section.title}
                  </h2>
                  <p className="text-sm md:text-base text-tie-text-secondary leading-relaxed">
                    {section.content}
                  </p>
                </div>
              </ScrollReveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}